import httpClient from "@/services/HttpService";

export default {

    languages: () => {
        return httpClient.get('/config/languages');
    }

}